import { Box, ButtonBase, FormControl, FormHelperText, FormLabel, MenuItem, Select } from '@mui/material';
import * as React from 'react';


export default function CustomSelectMultiple({
    values, onChange, error, data, title, required, disabled, placeholder, subtitle, parentName, name, valueName, labelName, width, height, noBorderRadius
}) {

    const handleDeleteFromValue = async (idx) => {
        let splicedArr = values;
        await splicedArr.splice(idx, 1);
        onChange(splicedArr);
    }
    return (
        <>
            <FormControl variant="outlined" fullWidth={width ? false : true}>
                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                <Select
                    size="small"
                    value={values}
                    name={name}
                    required={required}
                    disabled={disabled}
                    multiple
                    displayEmpty
                    placeholder={placeholder || 'Choose'}
                    onChange={(e) => { onChange(e.target.value) }}
                    style={{ color: (values === "" || values === "-1") ? "#c8c8c8" : 'inherit', width: width && width, height: height && height, borderRadius: noBorderRadius && 0 }}
                    IconComponent={() => (
                        <i className="ri-expand-up-down-line mx-2" style={{ color: '#101010' }} />
                    )}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }} onClick={(e) => e.stopPropagation()}>
                            {values?.length > 0 && values?.map((value, idx) => (
                                <div key={value} style={{ border: '1px solid #AAAAAA', color: '#101010', paddingInline: 5, backgroundColor: '#E4E4E4', borderRadius: 5 }} >
                                    <ButtonBase style={{ borderRight: '1px solid #AAAAAA', marginRight: 5 }} onMouseDown={(event) => { event.stopPropagation(); handleDeleteFromValue(idx) }}>
                                        <i className="ri-close-line" style={{ color: '#AAAAAA' }}></i>
                                    </ButtonBase>
                                    {data?.filter((x) => (x?.value || x?.id || x[`${valueName}`]) === value)[0]?.label || data?.filter((x) => (x.value || x.id || x[`${valueName}`]) === value)[0]?.name || data.filter((x) => (x.value || x.id || x[`${valueName}`]) === value)[0]?.[`${labelName}`]}{'\u00A0'}
                                    {parentName && data?.filter((x) => (x?.value || x?.id || x[`${valueName}`]) === value)[0]?.[parentName] ? `(${data?.filter((x) => (x?.value || x?.id || x[`${valueName}`]) === value)[0]?.[parentName]})` : ''}
                                </div>
                            ))}
                        </Box>
                    )}
                >
                    {
                        data && data.length > 0 && data.map((x, idx) =>
                            <MenuItem key={idx} value={x?.value || x?.id || x[`${valueName}`]} style={{ backgroundColor: (x?.value || x?.id) === values ? '#FEC00A' : 'white', }}>
                                {x?.label || x?.name || x?.[`${labelName}`]} {parentName && x?.[parentName] ? `(${x?.[parentName]})` : ''}
                            </MenuItem>
                        )
                    }
                </Select>
                <span style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{subtitle}</span>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
